import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Popover from '@material-ui/core/Popover';
import Picker from './Picker';
/**
 * @extends {React.Component<import('./types').ColorPickerPopover>}
 */

var ColorPickerPopover =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ColorPickerPopover, _React$Component);

  function ColorPickerPopover(props) {
    var _this;

    _classCallCheck(this, ColorPickerPopover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColorPickerPopover).call(this, props));
    _this.buttonRef = React.createRef();
    return _this;
  }

  _createClass(ColorPickerPopover, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onClose = _this$props.onClose,
          open = _this$props.open,
          rest = _objectWithoutProperties(_this$props, ["children", "onClose", "open"]);

      return React.createElement(React.Fragment, null, React.createElement("div", {
        ref: this.buttonRef
      }, children), React.createElement(Popover, {
        open: open,
        onClose: onClose,
        PaperProps: {
          style: {
            backgroundColor: 'transparent'
          }
        },
        elevation: 6,
        anchorEl: this.buttonRef.current,
        disableRestoreFocus: true,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        }
      }, React.createElement(Picker, rest)));
    }
  }]);

  return ColorPickerPopover;
}(React.Component);

ColorPickerPopover.defaultProps = {
  open: false
};
export default ColorPickerPopover;